module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Stogo nuolydis ir kryptis","text":"Nors idealus stogo nuolydžio kampas yra 30-40 laipsnių, o kryptis – pietūs, modulius sumontavus kitu kampu ir kryptimi, vis dar galima išsaugoti didelę dalį efektyvumo. Nogrid ekspertai pasiūlys tinkamiausią sprendimą Jūsų stogui!"}}')
  delete Component.options._Ctor
}
